<div class="banner">
  <img src="../../../../assets/images/gurantee.png" width="25px" />
  <span>平台安全有保障，工单客服在线时间8:00-24:00</span>
</div>

<mat-icon class="close" mat-dialog-close>close</mat-icon>

<div class="platform-info">
  <app-image [fileid]="selected?.icon" [radius]="8"></app-image>

  <div class="name">
    <h1>{{ data.name }}</h1>
    <div
      class="old"
      *ngIf="
        (selected?.platform_id === 67 && selected?.group === '全家桶') ||
        (selected?.platform_id === 3 && selected?.name === '一年')
      "
    >
      ￥
      {{
        (exclusive ? selected?.exclusive_price : selected?.price) || 0 | number
      }}
    </div>
    <div class="price">
      <div>
        <span class="rmb">￥</span>
        <ng-container
          *ngIf="
            (selected?.platform_id === 67 && selected?.group === '全家桶') ||
              (selected?.platform_id === 3 && selected?.name === '一年');
            else Else
          "
        >
          <span
            class="price"
            *ngIf="selected?.platform_id === 67 && selected?.group === '全家桶'"
          >
            {{
              (exclusive
                ? selected?.exclusive_price * 0.88
                : selected?.price * 0.88) || 0 | number: "1.2-2"
            }}
            <span style="font-size: 14px"> 全家桶八八折</span>
          </span>
          <span
            class="price"
            *ngIf="selected?.platform_id === 3 && selected?.name === '一年'"
          >
            {{
              (exclusive
                ? selected?.exclusive_price * 0.8
                : selected?.price * 0.8) || 0 | number: "1.2-2"
            }}
            <span style="font-size: 14px"> 限时8折</span>
          </span>
        </ng-container>
        <ng-template #Else>
          <span class="price">{{
            (exclusive ? selected?.exclusive_price : selected?.price) || 0
              | number
          }}</span>
          <span
            style="font-size: 14px"
            *ngIf="selected?.platform_id === 84 && selected?.name === '一年'"
          >
            加赠3个月，到手15个月</span
          >
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="divider"></div>

<ng-container *ngIf="!loading; else loadingTemplate">
  <div class="content">
    <div class="selection group" *ngFor="let item of displays; let i = index">
      <h1>{{ item?.[0].label }}</h1>
      <div class="items">
        <div class="item" *ngFor="let d of item; let j = index">
          <img
            *ngIf="
              (data.id === 67 && d.name === '全家桶') ||
              (data.id === 84 && d.name === '一年')
            "
            class="special"
            src="../../../../assets/images/discount-bus-type.png"
            alt=""
          />

          <button
            *ngIf="d?.items"
            mat-raised-button
            [color]="isSelected(i, j) ? 'primary' : ''"
            (click)="totalList(d.items, i + 1, j)"
          >
            {{ d.name }}
          </button>
          <button
            *ngIf="d?.bus_types"
            mat-raised-button
            [color]="isSelected(i, j) ? 'primary' : ''"
            (click)="totalList(d.bus_types, i + 1, j)"
          >
            {{ d.name }}
          </button>
        </div>
      </div>
    </div>

    <div class="tips">
      <span>
        {{ (exclusive ? selected?.exclusive_tips : selected?.tips) || "" }}
      </span>
    </div>

    <!-- <div
        class="divider introduce-divider"
        *ngIf="data.product_detail || data.product_image"
      ></div> -->
    <!--<div class="introduce" *ngIf="data.product_detail">
        <div class="introduce-title">商品介绍</div>
        <div class="introduce-detail">
          {{ data.product_detail }}
        </div>
      </div>
      <div class="introduce" *ngIf="data.product_image">
        <div class="introduce-title">商品详情</div>
        <img
          class="introduce-pic"
          src="/api/files/{{ data.product_image }}"
          alt=""
        />
      </div> -->

    <!-- <div class="introduce" [innerHTML]="data.product_detail"></div> -->
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <mat-spinner [diameter]="64"></mat-spinner>
</ng-template>

<!-- <div class="coupon">
    <span>优惠码</span>
    <div class="spacer"></div>
    <input
      [(ngModel)]="couponCode"
      placeholder="点击此处输入优惠码"
      spellcheck="false"
    />
    <button mat-flat-button (click)="checkCouponCode()">检查</button>
  </div> -->

<div class="button">
  <button
    mat-raised-button
    color="primary"
    class="purchase"
    [disabled]="!selected"
    (click)="purchase()"
  >
    立即购买
  </button>
</div>
